import { CategoryNamesAndIds } from '@/pages/DiscoverCategories/constants/constant';

import { urlSafeTitle } from '../urls';

/**
 * Resolves a top-level discover category slug (urlSafeTitle of display name) to category id.
 * Returns null when unknown — full browse resolution should use the category API.
 */
export const getTopCategoryIdFromSlug = (categorySlug: string): number | null => {
    const target = decodeURIComponent(categorySlug).toLowerCase();
    for (const [name, id] of Object.entries(CategoryNamesAndIds)) {
        if (urlSafeTitle(name).toLowerCase() === target) {
            return id;
        }
    }
    return null;
};
